import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import {
  Container,
  ImgWrapper,
  GithubIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
} from "./style"

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <Container>
            <hr />
            <ImgWrapper>
              <Image fixed={data.avatar.childImageSharp.fixed} alt={author} />
            </ImgWrapper>
            <p>
              <strong>{author}</strong> <br />
              {`  `}
              <a href={`https://github.com/${social.github}`}>
                <GithubIcon />
              </a>
              {`  `}
              <a href={`https://linkedin.com/in/${social.linkedin}`}>
                <LinkedinIcon />
              </a>
              {` `}
              <a href={`https://twitter.com/${social.twitter}`}>
                <TwitterIcon />
              </a>
              {` `}
              <a href={`https://instagram.com/${social.instagram}`}>
                <InstagramIcon />
              </a>
            </p>
          </Container>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.png/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
          github
          linkedin
          instagram
        }
      }
    }
  }
`

export default Bio
